
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Login from '../views/auth/Login';

import Posts from '../views/posts';

import PrivateRoute from './privateRoute';
import PublicRoute from './publicRoute';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store';
import { useDispatch } from 'react-redux'
import { refreshToken } from '../store/slices/auth';
// import Documents from '../views/my-potal/documents';
import RequestVacations from '../views/my-potal/request-vacations';
import RequestAbsence from '../views/my-potal/request-absence';
// import Benefits from '../views/my-potal/benefits';
import MyFile from '../views/my-potal/my-file';
import Birthday from '../views/portal/birthday';
import ApprovePosts from '../views/portal/approve-posts';
import Directory from '../views/portal/directory';
import Organization from '../views/organization';
import Approvals from '../views/in-my-charge/approvals';
import AbsenceHistory from '../views/in-my-charge/absence-history';
import ApprovalGroups from '../views/in-my-charge/approval-groups';
// import Areas from '../views/administration/areas';
import Coupons from '../views/administration/coupons';
import EmployeesPaymentsSlips from '../views/in-my-charge/employees-payments-slips';
import EmployeesContracts from '../views/in-my-charge/employees-contracts';
import Contracts from '../views/my-potal/contracts';
import PaymentSlips from '../views/my-potal/payments';
import Records from '../views/my-potal/records';
import ThreeColumnsPosts from '../views/posts/threeColumnsPosts';
import Calendar from '../views/in-my-charge/calendar';

import EmployeesDocuments from '../views/in-my-charge/employees-documents';
import ManagementAbsences from '../views/management/absence-history';
import ManagementEmployeesPaymentSlips from '../views/management/employees-payments-slips';
import ManagementEmployeesContracts from '../views/management/employees-contracts';
import ManagementEmployeesDocuments from '../views/management/employees-documents';
import NotificationGroupsView from '../views/administration/notifications-groups';
import AttendancePage from '../views/my-potal/attendance';
import RecoverPassword from '../views/auth/RecoverPassword';
import Loans from '../views/my-potal/loans';
import VacationResume from '../views/management/vacations-resume';
import LoansHistory from '../views/in-my-charge/loans';
import SupportLogin from '../views/SupportLogin';
import MyCalendar from '../views/my-potal/my-calendar';
import LicensesView from '../views/management/licences';
import AttendanceConsultView from '../views/in-my-charge/attendance';
import MyAttendances from '../views/my-potal/attendance/MyAttendances';
// import EmailLogsView from '../views/my-potal/email-logs-view';
import EmailRejectionTrackerView from '../views/administration/email-rejecteds';
import BirthdayConfigView from '../views/administration/birthday-config-view';
// import { useServiceAlert } from '../hooks/useServiceAlert';
// import ServiceAlertModal from '../components/ServiceAlertModal';

// const ScrollToTop = () => {
//   const { pathname } = useLocation();

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);

//   return null;
// }

function MyRoutes() {

  const dispatch = useDispatch<AppDispatch>();
  const authState = useSelector((state: RootState) => state.auth);
  // const { showAlert, handleShowAlert, handleCloseAlert, currentNotificationCount } = useServiceAlert();

  useEffect(() => {
    if (authState.companyselected) {
      dispatch(refreshToken(authState.companyselected.Token));
    }
		// eslint-disable-next-line
  }, [authState.companyselected]);


  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     handleShowAlert();
  //   }, 500);

  //   return () => clearTimeout(timer);
  // }, [handleShowAlert]);

  return (
    <BrowserRouter>
      {/* <ServiceAlertModal
        open={showAlert}
        onClose={handleCloseAlert}
        currentNotificationCount={currentNotificationCount}
      /> */}
        {/* <ScrollToTop /> */}
      <Routes>
        <Route path="/ingresar" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/recuperar-contrasena" element={<PublicRoute><RecoverPassword /></PublicRoute>} />

        {/* support */}
        <Route path="/support-login" element={<PrivateRoute hiddenHeader={true}><SupportLogin /></PrivateRoute>} />

        {/* my portal */}
        <Route path="/mi-portal/panel" element={<PrivateRoute><Posts /></PrivateRoute>} />
        <Route path="/mi-portal/registro-de-asistencia" element={<PrivateRoute><AttendancePage /></PrivateRoute>} />
        {/* <Route path="/mi-portal/documentos" element={<PrivateRoute><Documents /></PrivateRoute>} /> */}
        <Route 
          path="/mi-portal/vacaciones" 
          element={
            <PrivateRoute>
              <RequestVacations/>
            </PrivateRoute>
          }
        />
        <Route 
          path="/mi-portal/ausencias" 
          element={
            <PrivateRoute>
              <RequestAbsence/>
            </PrivateRoute>
          }
        />
        
        <Route path="/mi-portal/contratos" element={<PrivateRoute><Contracts /></PrivateRoute>} />
        
        <Route path="/mi-portal/mis-prestamos" element={<PrivateRoute><Loans /></PrivateRoute>} />

        <Route path="/mi-portal/boletas-de-pago" element={<PrivateRoute><PaymentSlips /></PrivateRoute>} />
        <Route path="/mi-portal/constancias" element={<PrivateRoute><Records /></PrivateRoute>} />

        {/* <Route path="/mi-portal/beneficios" element={<PrivateRoute><Benefits /></PrivateRoute>} /> */}
        <Route path="/mi-portal/mi-ficha" element={<PrivateRoute><MyFile /></PrivateRoute>} />
        <Route path="/mi-portal/calendario" element={<PrivateRoute><MyCalendar /></PrivateRoute>} />
        <Route path="/mi-portal/mis-marcaciones" element={<PrivateRoute><MyAttendances /></PrivateRoute>} />
        {/* <Route path="/mi-portal/mis-movimientos-bancarios" element={<PrivateRoute><EmailLogsView /></PrivateRoute>} /> */}
        

        {/* portal */}
        <Route path="/general/cumpleanos" element={<PrivateRoute><Birthday /></PrivateRoute>} />
        <Route path="/general/aprobar-publicaciones" element={<PrivateRoute><ApprovePosts /></PrivateRoute>} />
        <Route 
          path="/general/directorio" 
          element={
            <PrivateRoute key="/general/directorio">
              <Directory />
            </PrivateRoute>
          }
        />
        <Route 
          path="/general/organigrama" 
          element={
            <PrivateRoute key="/general/organigrama" hiddenHeader={true}>
              <Organization />
            </PrivateRoute>
          }
        />
        <Route path="/general/publicaciones" element={<PrivateRoute><ThreeColumnsPosts /></PrivateRoute>} />
        <Route 
          path="/general/programacion" 
          key="general-programacion"
          element={
            <PrivateRoute>
              <Calendar />
            </PrivateRoute>
          } 
        />

        {/* mi cargo */}
        <Route path="/a-mi-cargo/aprobaciones" element={<PrivateRoute><Approvals /></PrivateRoute>} />
        <Route 
          path="/a-mi-cargo/ausencias" 
          element={<PrivateRoute key={"a-mi-cargo-ausencias"}><AbsenceHistory couponId="-2"/></PrivateRoute>} 
        />
        <Route 
          path="/a-mi-cargo/vacaciones" 
          element={<PrivateRoute key={"a-mi-cargo-vacations"}><AbsenceHistory couponId="-1"/></PrivateRoute>} 
        />

        <Route 
          path="a-mi-cargo/boletas-de-pago" 
          key={"a-mi-cargo-boletas-de-pago"} 
          element={<PrivateRoute><EmployeesPaymentsSlips viewType='InMyCharge' /></PrivateRoute>} 
        />
        <Route 
          path="a-mi-cargo/contratos" 
          key={"a-mi-cargo-contratos"} 
          element={<PrivateRoute><EmployeesContracts viewType='InMyCharge' /></PrivateRoute>} 
        />
        <Route 
          path="a-mi-cargo/constancias" 
          key={"a-mi-cargo-constancias"} 
          element={<PrivateRoute><EmployeesDocuments viewType='InMyCharge' /></PrivateRoute>} 
        />
        <Route 
          path="/a-mi-cargo/programacion" 
          key="a-mi-cargo-programacion"
          element={
            <PrivateRoute>
              <Calendar />
            </PrivateRoute>
          } 
        />
        <Route 
          path="a-mi-cargo/resumen-de-vacaciones" 
          key={"a-mi-cargo-resumen-de-vacaciones"} 
          element={<PrivateRoute><VacationResume viewType='InMyCharge' /></PrivateRoute>} 
        />


        <Route 
          path="/a-mi-cargo/organigrama" 
          element={
            <PrivateRoute key="/a-mi-cargo/organigrama" hiddenHeader={true}>
              <Organization />
            </PrivateRoute>
          }
        />
        <Route 
          path="/a-mi-cargo/grupos-de-aprobacion" 
          element={<PrivateRoute key="a-mi-cargo"><ApprovalGroups /></PrivateRoute>}
        />
        <Route 
          path="/a-mi-cargo/marcaciones" 
          element={<PrivateRoute><AttendanceConsultView /></PrivateRoute>}
        />


        
        {/* aprobacion */}
        <Route 
          path="/aprobacion/programacion" 
          element={<PrivateRoute key={"aprobacion"}><Calendar /></PrivateRoute>} 
        />
        <Route 
          path="/aprobacion/ausencias" 
          element={<PrivateRoute key={"aprobacion-ausencias"}><AbsenceHistory couponId="-2" allowApproveOptions={true}/></PrivateRoute>} 
        />
        <Route 
          path="/aprobacion/vacaciones" 
          element={<PrivateRoute key={"aprobacion-vacations"}><AbsenceHistory couponId="-1" allowApproveOptions={true}/></PrivateRoute>} 
        />
        <Route 
          path="aprobacion/boletas-de-pago" 
          key={"aprobacion-boletas-de-pago"} 
          element={<PrivateRoute><EmployeesPaymentsSlips viewType='ToApprove' /></PrivateRoute>} 
        />
        <Route 
          path="aprobacion/contratos" 
          key={"aprobacion-contratos"} 
          element={<PrivateRoute><EmployeesContracts viewType='ToApprove' /></PrivateRoute>} 
        />
        <Route 
          path="aprobacion/constancias" 
          key={"aprobacion-constancias"} 
          element={<PrivateRoute><EmployeesDocuments viewType='ToApprove' /></PrivateRoute>} 
        />

        
        <Route 
          path="/aprobacion/prestamos" 
          element={
            <PrivateRoute key={"aprobacion-prestamos"}>
              <LoansHistory viewType='ToApprove'/>
            </PrivateRoute>
          }
        />

        {/* gestion */}
        
        <Route 
          path="/gestion/ausencias" 
          element={<PrivateRoute key={"gestion-ausencias"}><ManagementAbsences couponId="-2"/></PrivateRoute>} 
        />
        <Route 
          path="/gestion/vacaciones" 
          element={<PrivateRoute key={"gestion-vacations"}><ManagementAbsences couponId="-1"/></PrivateRoute>} 
        />
        <Route 
          path="gestion/boletas-de-pago" 
          key={"gestion-boletas-de-pago"} 
          element={<PrivateRoute><ManagementEmployeesPaymentSlips viewType='All' /></PrivateRoute>} 
        />
        <Route 
          path="gestion/contratos" 
          key={"gestion-contratos"} 
          element={<PrivateRoute><ManagementEmployeesContracts viewType='All' /></PrivateRoute>} 
        />
        <Route 
          path="gestion/constancias" 
          key={"gestion-constancias"} 
          element={<PrivateRoute><ManagementEmployeesDocuments viewType='All' /></PrivateRoute>} 
        />
        <Route 
          path="gestion/publicaciones" 
          key={"gestion-publicaciones"} 
          element={<PrivateRoute><ThreeColumnsPosts /></PrivateRoute>} 
        />
        <Route 
          path="gestion/resumen-de-vacaciones" 
          key={"gestion-resumen-de-vacaciones"} 
          element={<PrivateRoute><VacationResume viewType='All' /></PrivateRoute>} 
        />
        <Route 
          path="/gestion/gestion-de-licencias" 
          element={
            <PrivateRoute>
              <LicensesView />
            </PrivateRoute>
          }
        />
        
        {/* administracion */}
        <Route 
          path="/administracion/directorio" 
          element={
            <PrivateRoute key="/administracion/directorio">
              <Directory />
            </PrivateRoute>
          }
        />
        <Route 
          key="organigrama-admin"
          path="/administracion/organigrama" 
          element={
            <PrivateRoute key="organigrama-admin" hiddenHeader={true}>
              <Organization />
            </PrivateRoute>
          }
        />
        <Route 
          path="/administracion/grupos-de-aprobacion" 
          element={
            <PrivateRoute key="/administracion/grupos-de-aprobacion">
              <ApprovalGroups />
            </PrivateRoute>
          }
        />
        <Route 
          path="/administracion/grupos-de-notificacion" 
          element={
            <PrivateRoute key="/administracion/grupos-de-notificacion">
              <NotificationGroupsView />
            </PrivateRoute>
          }
        />
        {/* <Route path="/administracion/areas" element={<PrivateRoute><Areas /></PrivateRoute>} /> */}
        {/* TODO: delete */}
        <Route path="/administracion/cupones" element={<PrivateRoute><Coupons /></PrivateRoute>} />
        {/* TODO: end delete */}
        <Route path="/administracion/configuracion-de-tipos-de-ausencia" element={<PrivateRoute><Coupons /></PrivateRoute>} />
        
        <Route path="/administracion/email-rechazados" element={<PrivateRoute><EmailRejectionTrackerView /></PrivateRoute>} />
        <Route path="/administracion/configuracion-emails" element={<PrivateRoute><BirthdayConfigView /></PrivateRoute>} />
        
        

        <Route path="*" element={<PrivateRoute><label>Not found</label></PrivateRoute>} />
      
      </Routes>
    </BrowserRouter>
  );
}

export default MyRoutes;
